/* FGR4 V4 / Build 05. Progressive, keyboard-accessible interactions. Native Shopify forms/gallery/checkout are untouched. */
(function () {
  'use strict';
  var motionAllowed = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSignal(root) {
    if (root.dataset.ready === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-f5-slide]'));
    if (slides.length < 1) return;
    root.dataset.ready = 'true';
    var active = 0;
    var counter = root.querySelector('[data-f5-signal-count]');
    var timer = null;
    var hovering = false;
    var focusing = false;
    function show(next) {
      active = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== active; });
      if (counter) counter.textContent = String(active + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    }
    function stop() { if (timer !== null) { window.clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (slides.length < 2 || !motionAllowed || root.dataset.auto !== 'true' || hovering || focusing || document.hidden) return;
      timer = window.setInterval(function () { show(active + 1); }, Math.max(4000, Number(root.dataset.delay) || 7000));
    }
    function go(delta) { show(active + delta); start(); }
    var prev = root.querySelector('[data-f5-signal-prev]');
    var next = root.querySelector('[data-f5-signal-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    root.addEventListener('mouseenter', function () { hovering = true; stop(); });
    root.addEventListener('mouseleave', function () { hovering = false; start(); });
    root.addEventListener('focusin', function () { focusing = true; stop(); });
    root.addEventListener('focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      focusing = false; start();
    });
    document.addEventListener('visibilitychange', start);
    show(0); start();
  }

  function initShowcase(root) {
    if (root.dataset.ready === 'true') return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-f5-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-f5-panel]'));
    if (tabs.length < 2) return;
    root.dataset.ready = 'true';
    var tablist = root.querySelector('.f5-showcase__tabs');
    function select(id, focus) {
      tabs.forEach(function (tab) {
        var selected = tab.dataset.f5Tab === id;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
      panels.forEach(function (panel) { panel.hidden = panel.dataset.f5Panel !== id; });
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { select(tab.dataset.f5Tab, false); });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault(); select(tabs[nextIndex].dataset.f5Tab, true);
      });
    });
    if (tablist) tablist.hidden = false;
    select(tabs[0].dataset.f5Tab, false);
    root.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest('[data-f5-panel]');
      if (panel) select(panel.dataset.f5Panel, false);
    });
  }

  function initLookbook(root) {
    if (root.dataset.ready === 'true') return;
    var sources = Array.prototype.slice.call(root.querySelectorAll('[data-f5-lookbook-sources] [data-src]'));
    var dialog = root.querySelector('[data-f5-lightbox]');
    var image = root.querySelector('[data-f5-lookbook-image]');
    if (!dialog || !image || !sources.length) return;
    root.dataset.ready = 'true';
    var active = 0;
    var caption = root.querySelector('[data-f5-lookbook-caption]');
    var lastTrigger = null;
    function show(index) {
      active = (index + sources.length) % sources.length;
      image.src = sources[active].dataset.src;
      image.alt = sources[active].dataset.alt || '';
      if (caption) caption.textContent = (active + 1) + ' / ' + sources.length;
    }
    root.querySelectorAll('[data-f5-lookbook-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        lastTrigger = trigger;
        show(Number(trigger.dataset.f5LookbookOpen) || 0);
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else window.open(image.src, '_blank', 'noopener');
      });
    });
    root.querySelector('[data-f5-lookbook-close]').addEventListener('click', function () { dialog.close(); });
    root.querySelector('[data-f5-lookbook-prev]').addEventListener('click', function () { show(active - 1); });
    root.querySelector('[data-f5-lookbook-next]').addEventListener('click', function () { show(active + 1); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1); }
    });
    dialog.addEventListener('close', function () { image.removeAttribute('src'); if (lastTrigger) lastTrigger.focus(); });
  }

  function initCollectionStage(root) {
    if (root.dataset.ready === 'true') return;
    var image = root.querySelector('.f4-collection-intro__image');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-f5-collection-src]'));
    if (!image || buttons.length < 2) return;
    root.dataset.ready = 'true';
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.getAttribute('aria-pressed') === 'true') return;
        image.removeAttribute('srcset'); image.removeAttribute('sizes');
        image.src = button.dataset.f5CollectionSrc;
        image.alt = button.dataset.f5CollectionAlt || image.alt;
        buttons.forEach(function (other) {
          var selected = other === button;
          other.setAttribute('aria-pressed', String(selected));
          other.classList.toggle('is-active', selected);
        });
      });
    });
  }

  function initReveal() {
    if (!motionAllowed || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) return;
    var candidates = document.querySelectorAll('.f4-stage__copy, .f4-stage__visual, .f5-showcase__head, .f5-showcase__focus, .f5-social__copy, .f5-social__media, .f4-partner__copy, .f4-partner__art');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('f5-in-view');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -35px 0px', threshold: 0.05 });
    candidates.forEach(function (element) {
      if (element.dataset.f5Observed) return;
      element.dataset.f5Observed = 'true';
      element.classList.add('f5-reveal');
      observer.observe(element);
    });
  }

  function init() {
    document.querySelectorAll('[data-f5-signal]').forEach(initSignal);
    document.querySelectorAll('[data-f5-showcase]').forEach(initShowcase);
    document.querySelectorAll('[data-f5-lookbook]').forEach(initLookbook);
    document.querySelectorAll('[data-f5-collection-stage]').forEach(initCollectionStage);
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
